<template>
  <div class="app-container">
    <div class="order-btn">
      <vxe-button @click="returnFun()">返回</vxe-button>
      <vxe-button status="primary" @click="debounceCommitFun">提交</vxe-button>
      <!-- <a-tooltip style="margin-left: 5px;">
        <template #title>请确认添加的物料已经保存后再提交，否则添加的物料将不能真正保存进订单</template>
        <a-icon type="info-circle"></a-icon>
      </a-tooltip> -->
    </div>
    <a-divider />
    <div class="orderFormLine">订单信息</div>
    <div class="budgetBox">
      <a-form-model ref="orderForm" class="UniformCss" :inline="true" :model="order" :rules="rules" label-width="100px">
        <a-row>
          <a-col :span="4">
            <a-form-model-item label="订单编号" prop="applyOrderCode">
              <a-input v-model="order.applyOrderCode" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="申领部门" prop="orgName">
              <a-input v-model="order.orgName" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="申领人" prop="applyMan">
              <a-input v-model="order.applyMan" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="申领日期" prop="applyTime">
              <a-input v-model="order.applyTime" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="订单总项数" prop="orderMaterialCount">
              <a-input v-model="order.orderMaterialCount" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="订单总数量" prop="orderNums">
              <a-input v-model="order.orderNums" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="订单总金额" prop="orderTotalSums">
              <a-input v-model="order.orderTotalSums" :disabled="true" />
            </a-form-model-item>
          </a-col>
          <!-- lr0017 -->
          <!-- <a-col :span="6">
            <a-form-model-item label="领料人" prop="drawMan">
              <a-input v-model="order.drawMan" clearable />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="领料用途" prop="drawFor">
              <a-input v-model="order.drawFor" clearable />
            </a-form-model-item>
          </a-col> -->
          <!-- <a-col :span="6">
            <a-form-model-item label="领用部门" prop="drawOrz">
              <a-input v-model="order.drawOrz" clearable />
            </a-form-model-item>
          </a-col> -->

          <!-- <vxe-column type="checkbox" width="60" align="center" /> -->
       
          <a-col :span="4">
            <a-form-model-item label="收货人" prop="receiver"> 
              <!-- <a-input v-model="order.receiver" clearable /> -->
              <a-select v-model="order.receiver" placeholder="收货人" @change="diseaseChange" clearable > 
                <a-select-option
                  v-for="item in romotionOrderStatus"
                  :key="item.id"
                  :value="item.id"
                >{{ item.recipientName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <!-- <a-col :span="4">
            <a-form-model-item label="收货人姓名" prop="receiverName">
              <a-input v-model="order.receiverName" disabled clearable />
            </a-form-model-item>
          </a-col> -->

          <a-col :span="4">
            <a-form-model-item label="收货人联系方式" prop="receivePhone">
              <a-input v-model="order.receivePhone" disabled clearable />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="收货地址" prop="address">
              <a-input v-model="order.address" placeholder="收货地址" disabled clearable />
            </a-form-model-item>
          </a-col> 
        </a-row>


          <!-- <a-col :span="6">
            <a-form-model-item label="收货地区" prop="receiveArea">
              <a-input v-model="order.receiveArea" disabled />
            </a-form-model-item>
          </a-col> -->


              <!-- <a-cascader
              v-model="area"
              :options="areaOptions"
              :fieldNames="{ label: 'areaName', value: 'areaId', children: 'children' }"
              placeholder="请选择所在省市区"
              @change="handleChange"
              allowClear
            /> -->
             
              <!-- <a-cascader ref="areaCascader" v-model="area" :options="areaOptions" :props="areaLabel" @change="handleChange" /> -->
           
     
          <!-- <a-col :span="6">
            <a-form-model-item label="物流单号">
              <a-input v-model="order.logisticsOrderCode" placeholder="物流单号" clearable />
            </a-form-model-item>
          </a-col> -->

        <div style="display:flex; justify-content: center; padding-bottom: 1px">
          <vxe-button status="primary" style="margin-top: 1px" @click="saveOrderInfo('orderForm')">保存</vxe-button>
        </div>
      </a-form-model>
    </div>

    <div class="orderFormLine">物料信息
      <a-tooltip v-if="!order.id">
        <template #title>保存订单后显示添加物料按钮</template>
        <!-- <i class="el-icon-info" style="color:#409EFF;" /> -->
        <a-icon type="info-circle"></a-icon>
      </a-tooltip>
    </div>
    <div class="budgetBox">
      <div style="padding: 10px 0">
        <!-- <vxe-button v-if="btnEnable" status="primary" @click="dialogVisible= true ">添加物料</vxe-button> -->
        <vxe-button v-if="btnEnable" @click="addMateWu">添加</vxe-button>
        <vxe-button v-if="btnEnable" status="primary" @click="handleDelete">删除</vxe-button>
        <!-- <vxe-button v-if="btnEnable" status="primary" @click="materialSave">正式保存</vxe-button> -->
        <!-- <vxe-button v-if="editFlag" status="danger" @click="cancelAll">取消所有</vxe-button> -->
        <SelectMaterialDialog :visible.sync="dialogVisible" @addMaterial="addMaterial" />
      </div>
      <div>
        <vxe-table
          ref="xTable"
          border
          resizable
          stripetrue
          keep-source
          show-header-overflow
          show-overflow
          :max-height="$store.state.app.height - 170 < 300 ? 300 : $store.state.app.height - 170"
          align="center"
          :data="tableData"
          :edit-config="{trigger: 'manual', mode: 'row', autoClear: false, showStatus: true}"
        >
          <vxe-column type="checkbox" width="40" />
          <vxe-column type="seq" title="序号" width="60" />
          <vxe-column field="materialCode" title="物料号" width="150" />
          <vxe-column field="materialName" title="物料名称" width="250" />
          <vxe-column field="materialType" title="物料类型" width="100">
            <template #default="{ row }">
              <span v-if="row.materialType === '1'">销售物料</span>
              <span v-else-if="row.materialType === '2'">礼品物料</span>
              <span v-else-if="row.materialType === '3'">宣传物料</span>
              <span v-else-if="row.materialType === '4'">其它</span>
              <span v-else-if="row.materialType === '5'">产品资料</span>
              <span v-else-if="row.materialType === '6'">手册</span>
              <span v-else>{{ row.materialType }}</span>
            </template>
          </vxe-column>
          <vxe-column field="storage" title="数量" width="80"/>
          <vxe-column field="price" title="申领价" width="80"/>

          <!-- <vxe-column field="nums" title="申领数量" :edit-render="{}" width="100">
            <template #edit="{ row }">
              <vxe-input v-model="row.nums" type="number" min="0" :max="row.storage" placeholder="请输入数量" />
            </template>
          </vxe-column> -->

             <vxe-column field="nums" title="申领数量"  width="80">
            <template #default="{ row }">
              <vxe-input v-model="row.nums" type="number" min="0" :max="row.storage" placeholder="请输入数量" />
            </template>
          </vxe-column>
    
          <vxe-column field="totalSums" title="申领总金额" width="100">
            <template #default="{ row }">
              <span>{{ countTotalSums(row) }}</span>
            </template>
          </vxe-column>
       
          <!-- <vxe-column field="applyRemarks" title="申领用途" width="200" :edit-render="{}">
            <template #edit="{ row }">
              <vxe-input v-model="row.applyRemarks" type="text" />
            </template>
          </vxe-column> -->

          <vxe-column field="applyRemarks" title="申领用途" width="250" >
            <template #default="{ row }">
              <vxe-input v-model="row.applyRemarks" type="text" />
            </template>
          </vxe-column>


          <!--<vxe-column title="操作" width="140">
            <template #default="{ row }">
              <template v-if="$refs.xTable.isActiveByRow(row)">
                <a-button size="small" type="link" @click="cancelRowEvent(row)">编辑</a-button>
              </template>
              <template>
                <a-button size="small" type="link" @click="cancelRowEvent(row)">取消临时物料</a-button>
              </template>

              <template v-if="$refs.xTable.isActiveByRow(row)">  lr0040
                <a-button size="small" type="link" @click="cancelRowEvent(row)">取消</a-button>
              </template>
              <template v-else>
                <a-button size="small" type="link" @click="editRowEvent(row)">编辑</a-button>
              </template>

            </template>
          </vxe-column> -->
        </vxe-table>
      </div>
    </div> 

    <a-modal title="审批信息" :visible.sync="appdialogVisible" width="40%" @cancel="appdialogVisible=false">
      <el-input
        v-model="approveMsg"
        type="textarea"
        placeholder="请输入审批意见"
        maxlength="300"
        show-word-limit
      />
      <!--  -->
      <span slot="footer" class="dialog-footer">
        <vxe-button status="primary" :loading="approveBtnLoading" @click="approveLiuCheng()">{{submitName}}</vxe-button>
        <vxe-button @click="appdialogVisible = false">取 消</vxe-button>
      </span>
    </a-modal>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import { saveApplyOrder, commitOrder, saveOrderMaterial, getOrderById, findList4MaterialApply, 
deleteOrderMaterial, findAddressListByUserNo, getMaterialApplyProcessCode } from '@/api/material'
import _ from 'lodash'
// import { getAreaTree } from '@/api/base-data'
import SelectMaterialDialog from './components/SelectMaterialDialog.vue'
// import XEUtils from "xe-utils";
import { loadAreaTreeCasData } from '@/services/baseCodeSource';
import { approveStart, approveRestart } from '@/api/wf_process.js'
import { saveApplyOrderInfo, updateOrderStatus } from '@/api/actPlan.js'
import { dateFormat } from '@/utils/DateUtils'
// import { ColumnConfig } from 'vxe-table';

// {{ user.deptName }}
export default {
  name: 'ApplyOrder',
  components: {
    SelectMaterialDialog
  },
  computed: {
    ...mapGetters('account', ['user']),
  },
  data() {
    return {
      addresses: [],
      approveBtnLoading: false,
      appdialogVisible: false,
      approveMsg: '',
      order: {
        orgName: '',
        orderMaterialCount: 0,
        orderNums: 0,
        orderTotalSums: 0,
        provinceId: 0,
        cityId: 0,
        countyId: 0,
        receiveArea: '',
        logisticsOrderCode: ''     // 物流单号
      },
      rules: {
        drawMan: [{ required: true, message: '请输入领料人', trigger: 'blur' }],
        drawFor: [{ required: true, message: '请输入领料用途', trigger: 'blur' }],
        drawOrz: [{ required: true, message: '请输入领用部门', trigger: 'blur' }],
        receiver: [{ required: true, message: '请选择收货人', trigger: 'change' }],
        receivePhone: [{ required: true, message: '请输入联系方式', trigger: 'blur' },{ pattern: /^[1][3-9][0-9]{9}$/, message: '请输入有效的手机号码', trigger: 'blur' }],
        receiveArea: [{ required: true, message: '请选择收货地区', trigger: 'change' }],
        address: [{ required: true, message: '请输入收货地址', trigger: 'blur' }],
      },
      dialogVisible: false,
      btnEnable: false,
      // btnEnable1: false,
      editFlag: true,
      materialSelection: [],
      areaOptions: [],
      areaLabel: {
        value: 'id',
        label: 'label',
        children: 'children'
      },
      area: [],
      areaEnable: false,
      tableData: [],
      romotionOrderStatus: [],
      ApplyProCode: '',
      submitType:'',
      submitName:'发起审批',
      uniqueCodes: new Set()
  }
},
  // computed: {
    // ...mapGetters(['userinfo'])
  // },
  watch: {
    areaEnable: function() {
      this.getArea()
    }
  },
  created() {
    if (this.$route.params.id !== 'null') {
      this.order.id = this.$route.params.id
      this.btnEnable = true
      // this.btnEnable1 = false
      this.findAddressListByUserNo().then(() => {
        this.getData()
      })
      this.getData1()
      this.findOrderMaterialList()
    } else {
      this.initOrder()
      this.getArea()
      this.findAddressListByUserNo()
    }
    this.getMaterialApplyProcessCode()
    console.log(this.uniqueCodes,'create')
},
  mounted() {
    console.log(this.uniqueCodes,'mounted')
  },
  methods: {
      handleDelete() {
        const selectedRows = this.$refs.xTable.getCheckboxRecords();
        if (selectedRows.length === 0) {
          this.$message.warning('请至少选择一条数据');
          return;
        }
        selectedRows.forEach(row => {
          if (row.id) {
            this.materialDelete();
          } else {
            this.cancelRowEvent(row);
          }
        });
      },

    // 防抖提交方法
    debounceCommitFun: _.debounce(function() {
      this.commitFun();
    }, 500, { leading: true, trailing: false }),

    // 提交订单审核
    async commitFun() {
      try {
        await this.materialSave();

        if (this.order.id) {

          // commitOrder(this.order).then(res => {
          //   if (res.code === 1) {
          //     this.$message.success('提交成功')
          //     if(this.$route.params.id !== 'null') {
          //       this.returnListFun()
          //     }else {
          //       // 成功之后发起流程
          //       this.appdialogVisible = true
          //     }

          //   } else {
          //     this.$message.error(res.message)
          //   }
          // })


          // if(this.$route.params.id !== 'null' && this.$route.query.orderStatus !== '0') {
          //   commitOrder(this.order).then(res => {
          //     if (res.code === 1) {
          //       this.returnListFun()
          //     } else {
          //       this.$message.error(res.message)
          //     }
          //   })
          // }else {
          //   // 成功之后发起流程
          //   this.appdialogVisible = true
          // }


          if(this.$route.params.id == 'null') {
            // 成功之后发起流程
            this.appdialogVisible = true
            this.submitType = '1'
            this.submitName = '发起审批'
          }else if(this.$route.params.id !== 'null' && this.$route.query.orderStatus == '0') {
            // 成功之后发起流程
            this.appdialogVisible = true
            this.submitType = '1'
            this.submitName = '发起审批'
          }else if(this.$route.params.id !== 'null' && this.$route.query.orderStatus == '3') {
            this.appdialogVisible = true
            this.submitType = '2'
            this.submitName = '重新发起审批'
          }
        } else {
          this.$message.warning('请先保存订单')
        }
      }catch (error) {
        console.log('保存过程出现错误:', error)
      }
    },
    
    // 获取物料申领流程的流程编码
    getMaterialApplyProcessCode() {
      getMaterialApplyProcessCode().then(res => {
          if (res.code === 1) {
            this.ApplyProCode = res.data
            console.log(res,'------获取物料申领流程的流程编码------');
          }
        })
    },
    
    //  流程
    approveLiuCheng() {
      if (this.approveMsg === '') {
          this.approveBtnLoading = false
          this.$message.warning('审批意见不能为空')
          return
        }
      if(this.submitType == '1') {
        commitOrder(this.order).then(res => {
          if (res.code === 1) {
            // this.$message.success('提交成功')
            // if(this.$route.params.id !== 'null') {
            //   this.returnListFun()
            // }else {
            // }else {
            //   // 成功之后发起流程
            //   this.returnProcess()
            // }
            
            // 成功之后发起流程
            this.returnProcess()
            
          } else {
            this.$message.error(res.message)
          }
        })
      }else if(this.submitType == '2'){
        this.approveRestartFun()
      }
    },

    // 发起审批
    returnProcess() {
      this.$store.dispatch('SelectData/QuerySelect', ['materialApplyProcessMap']).then(v => {
        console.log(v,'---v-----')
        // const obj = v.materialApplyProcessMap.find(item => item.code === this.currentRow.budgetTypeCode)
        // if (!obj) {
        //   this.$message.error('该预算类型未配置核销审批流')
        //   return
        // }
        const obj = v.materialApplyProcessMap.find(item => item.code == this.ApplyProCode)
        console.log(obj,'----obj');
        const approveParam = {
          processName: obj.value,
          args: {
            applyOrderCode:this.order.applyOrderCode,
            orderNums:this.order.orderNums,
            approveMsg: this.approveMsg,
            orderTotalSums:this.order.orderTotalSums,
            drawMan:this.order.drawMan,
            drawFor:this.order.drawFor,
            operateType: '发起审批'
          }
        }
        this.approveBtnLoading = true
        // 发起流程
        approveStart(approveParam).then(res => {
          if (res.code === 1) {
            let params = {
              id: this.order.id,
              applyOrderId: res.data.orderId,
              applyAuditorNames: res.data.operatorInfos[0].operatorNames,
              applyAuditorIds: res.data.operatorInfos[0].operatorIds,
              applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date()),
              processName: obj.value
            }
            saveApplyOrderInfo(params).then(v => {
              if (v.code === 1) {
                this.approveBtnLoading = false
                this.appdialogVisible = false
                this.returnListFun()
              }
            })
          }
        })
      })
    },

    // 重新发起
    approveRestartFun() {
      updateOrderStatus(this.order.id).then(v => {
        if (v.code === 1) {
          console.log(v);
        }
      })

      const approveParam = {
        orderId: this.order.applyOrderId,
        processName: this.order.processName, 
        args: {
          applyOrderCode:this.order.applyOrderCode,
          orderNums:this.order.orderNums,
          approveMsg: this.approveMsg,
          orderTotalSums:this.order.orderTotalSums,
          drawMan:this.order.drawMan,
          drawFor:this.order.drawFor,
          operateType:"重新发起审批"
          // S-ACTOR:""
        }
      }
      this.approveBtnLoading = true
      approveRestart(approveParam).then(res => {
        this.approveBtnLoading = false
        if (res.code === 1) {
          // this.appdialogVisible = false  // 关闭审批弹框
          // this.returnListFun()

          let params = {
              id: this.order.id,
              applyOrderId: res.data.orderId,
              applyAuditorNames: res.data.operatorInfos[0].operatorNames,
              applyAuditorIds: res.data.operatorInfos[0].operatorIds,
              applyFlowStart: dateFormat('YYYY-mm-dd HH:MM:SS', new Date())
            }
            saveApplyOrderInfo(params).then(v => {
              if (v.code === 1) {
                this.approveBtnLoading = false
                this.appdialogVisible = false  // 关闭审批弹框
                this.returnListFun()
              }
            })
        }else {
          this.$message.error(res.message)
          this.appdialogVisible = false  // 关闭审批弹框
        }
      })
    },




    async getData() {
      await getOrderById(this.order.id).then(res => {
        if (res.code === 1) {
          this.order = res.data
          {
            const hit = this.romotionOrderStatus.find(item => String(item.id) == String(res.data.receiver))
            this.order.receiver = hit ? hit.id : res.data.receiver
          }
          this.diseaseChange(this.order.receiver)
          console.log(res,'--getData order');
          this.area.push(res.data.provinceId, res.data.cityId)
          if (res.data.countyId !== 0) {
            this.area.push(res.data.countyId)
          }
          this.areaEnable = true
        } else {
          this.$message.error(res.message)
        }
      })},

      async getData1() {
      await findList4MaterialApply({ orderId: this.order.id }).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
      console.log('getdata1',this.tableData)
    },

    

    //  获取 收货人列表
    async findAddressListByUserNo() {
      let params = {
        userNo: this.user.userNo,
        isAdmin: this.user.mainRoleName == '系统管理员' ? 1 : 0
      }
      await findAddressListByUserNo(params).then(res => {
        this.romotionOrderStatus = res.data
      })
    },

    // 
    diseaseChange(val) {
      let newArr = this.romotionOrderStatus.filter(item => item.id == val)
      let data = newArr[0]
      this.order.receivePhone = data.contactPhone
      this.order.receiveArea = data.region.replace(/,/g, '/')
      this.order.address = data.detailedAddress
      this.order.receiverName = data.recipientName
    },
    


    // 初始化订单号和时间
    initOrder() {
      const userInfo = this.$store.getters['account/user']
      const date = new Date()
      // 申领时间
      this.order.applyTime = date.toLocaleDateString().split('/').join('-')
      // 申领人
      this.order.applyMan = userInfo.userName
      this.order.orgName = userInfo.deptName
      // 订单编号
      const year = String(date.getFullYear())
      const month = date.getMonth() + 1
      const day = date.getDate()
      // 取年份后两位
      let code = 'SL' + year.slice(2)
      if (month >= 10) {
        code += month
      } else {
        code += '0' + month
      }

      if (day >= 10) {
        code += day
      } else {
        code += '0' + day
      }
      this.order.applyOrderCode = code + Math.floor(Math.random() * 1000000)
    },
    // 获取订单信息
    findOrder() {
      getOrderById(this.order.id).then(res => {
        if (res.code === 1) {
          this.order = res.data
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取订单所包含的物料信息
    findOrderMaterialList() {
      findList4MaterialApply({ orderId: this.order.id }).then(res => {
        if (res.code === 1) {
          this.tableData = res.data.list
          // 数据加载完成后收集物料号
          if (this.tableData && this.tableData.length > 0) {
            this.tableData.forEach(item => {
              if (item.materialCode) {
                this.uniqueCodes.add(item.materialCode)
              }
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 获取地区表
    async getArea() {
      this.areaOptions = await loadAreaTreeCasData();
    },
    // 地区选择改变回调函数
    handleChange(value, selectedOptions) {
      console.log("🚀 ~ handleChange ~ selectedOptions:", selectedOptions)
      this.order.receiveArea = selectedOptions.map(item=>item.areaName).join('/')
      this.order.provinceId = value[0] // 第一个值设为省id
      this.order.cityId = value[1] // 第二个值设为城市id
      // 存在第三个值则设为区县id
      if (value[2]) {
        this.order.countyId = value[2]
      } else {
        this.order.countyId = 0
      }
    },
    // 保存订单信息
    saveOrderInfo() {
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          this.order.applyTime = ''

          saveApplyOrder(this.order).then(res => {
            if (res.code === 1) {
              this.order = res.data
              {
                const hit = this.romotionOrderStatus.find(item => String(item.id) == String(res.data.receiver))
                this.order.receiver = hit ? hit.id : res.data.receiver
              }
              this.diseaseChange(this.order.receiver)

              this.$message.success('保存成功')
              this.btnEnable = true
            } else {
              this.$message.error('保存失败')
            }
          })
        } else {
          this.$message.warning('请完善信息!')
          return false
        }
      })
    },
    // 添加临时物料，只是临时添加
    async addMaterial(selections) {
      //一、使用some方法遍历selections数组，检查是否有重复物料号
      const hasDuplicates = selections.some(item => {
        if(this.uniqueCodes.has(item.materialCode)) {
          return true
        } 
        this.uniqueCodes.add(item.materialCode)
        return false
      })
      console.log(this.uniqueCodes,'添加物料')
      console.log(hasDuplicates,'hasDuplicates')

      if(hasDuplicates === true){
        console.log(hasDuplicates,'hasDuplicates+if')
        this.$message.warning('选择的物料中存在重复物料号，请检查')
        return
      }
      // 二、使用some方法检查tableData数组 判断是否存在item2的materialCode与当前item1的materialCode相同
      let newArr = null
        // newArr = selections.filter(item1 => {
        //   return !this.tableData.some(item2 => item2.materialCode === item1.materialCode);
        // });
        newArr = selections
        if (newArr.length !== 0) {
          this.dialogVisible = false // 关闭物料选择框
          const $table = this.$refs.xTable
          const newRecord = newArr
          const { row: newRow } = await $table.insertAt(newRecord, -1) // 临时添加进vxeTable
          $table.setActiveRow(newRow) // 最后一条设为编辑状态

        // this.btnEnable1 = true
        // this.editFlag = true
      } 
      else {
        this.$message.warning('请选择添加的物料,请勿重复添加物料')
      // }
    }
  },
    addMateWu() {
      // alert('2')
      this.dialogVisible = true
      
    },
    

//     cancelRowEvent(row) {
//       const $table = this.$refs.xTable
//         $table.clearActived().then(() => {
//           // 检查物料号是否在uniqueCodes集合中
//       if (row.materialCode && this.uniqueCodes.has(row.materialCode)) {
//       this.uniqueCodes.delete(row.materialCode)
//         // 删除数据
//           $table.remove(row)
//         }})
//       }
//   }
// }
    // 正式删除
    materialDelete() {
      const $table = this.$refs.xTable
      const selections = $table.getCheckboxRecords() // 获取选中的数据
      // $table.clearActived().then(() => {
        // if (row.materialCode && this.uniqueCodes.has(row.materialCode)) {
        //   this.
        //   uniqueCodes.delete(row.materialCode)}
        // })
        const hasDuplicatess = selections.some(item => {
        if(this.uniqueCodes.has(item.materialCode)) {
          this.uniqueCodes.delete(item.materialCode)
          return false }})

        // } 
        // this.uniqueCodes.add(item.materialCode)
        // return false
      if(hasDuplicatess){
        this.$message.warning('xxxxx')
        return
      }
        console.log(this.uniqueCodes,'删除物料')

        const data = []
      if (selections.length > 0) {
        selections.forEach(item => {
          // 通过id判断是否是临时数据，不是则放进data
          if (item.id) {
            data.push(item)
          }
        })
        // 发送删除请求
        deleteOrderMaterial(data).then(res => {
          if (res.code === 1) {
            $table.removeCheckboxRow() // 删除vxeTable的数据
            this.order = res.data
            this.$message.success('删除成功')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    // // 取消所有编辑，临时数据会直接删除
    // cancelAll() {
    //   const $table = this.$refs.xTable
    //   const list = $table.getTableData().tableData
    //   if (list.length > 0) {
    //     list.forEach(item => {
    //       // 通过id判断是否是临时数据
    //       if (item.id) {
    //         // 取消编辑状态
    //         $table.clearActived().then(() => {
    //         // 还原行数据
    //           $table.revertData(item)
    //         })
    //       } else {
    //         $table.clearActived().then(() => {
    //         // 删除数据
    //           $table.remove(item)
    //         })
    //       }
    //     })
    //   }
    //   this.btnEnable = true
    //   this.editFlag = false
    // },
    // 计算申领总金额
    countTotalSums(row) {
      const totalSums = Number((row.price * row.nums).toFixed(10)) || 0
      row.totalSums = totalSums
      return Number((row.price * row.nums).toFixed(10)) || 0
    },
    // 正式保存
/*
    materialSave() {

      // 单条保存
      const $table = this.$refs.xTable
      const selections = $table.getCheckboxRecords() // 获取选中的数据
      var data = []
      var save = true 
      if (selections.length === 0) {
        this.$message.warning('请选择需要保存的物料')
      } else {
        selections.forEach(item => {
          if (item.nums == null) {
            this.$message.warning('申领数量不能为空')
            save = false
            return
          }
          if (item.nums <= 0) {
            this.$message.warning('申领数量不能小于0')
            save = false
            return
          }
          if (item.nums > item.storage) {
            this.$message.warning('申领数量不能大于库存')
            save = false
            return
          }
          // lr0051
          if (item.materialType === '2' && !item.applyRemarks) {
            this.$message.warning('物料类型为礼品类时，申领用途必填')
            save = false
            return
          }
          item.orderId = this.order.id
          // 检查item对象是否有updateTime属 这是一个条件判断，用于确定是否需要执行删除操作？
          if (item.updateTime) {
            delete item.updateTime
          }
          data.push(item)
        })

        if (save) {
          saveOrderMaterial(data).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')

               // 保存成功后，清理未保存行的materialCode
              //  创建一个Set集合savedMaterialCodes 
              //  使用map方法从selections数组(被选中的行)中提取每个row的materialCode
         
        // 条件判断：如果当前行的materialCode不在savedMaterialCodes中(未被选中保存) 
        // 且这个materialCode存在于uniqueCodes集合中
      //   
              // this.btnEnable = true
              // this.editFlag = false
              // this.btnEnable1 = false

              // 只更新当前保存行的btnEnable1状态
              // selections.forEach(selected => {
              //   const index = this.tableData.findIndex(row => row.id === selected.id)
              //   if (index !== -1) {
              //     const newRow = {...this.tableData[index], btnEnable1: false}
              //     this.$set(this.tableData, index, newRow)
              //   }
              // })
              // $table.clearCheckboxRow()
              this.getData()
              this.getData1()

            } else {
              this.$message.error(res.message)
              console.log(this.uniqueCodes,'正式保存2')
              console.log(this.tableData,'tabledata')
            }
          })
        }
      }
    },*/

    materialSave() {
      return new Promise((resolve, reject) => {
        // 默认保存全部
        const $table = this.$refs.xTable
        $table.setAllCheckboxRow(true)
        const selections = $table.getCheckboxRecords()
        var data = []
        var save = true

        if (selections.length === 0) {
          this.$message.warning('请选择需要保存的物料')
          reject(new Error('未选择物料')) // 保存失败，拒绝Promise
          return
        }

        selections.forEach(item => {
          if (item.nums == null) {
            this.$message.warning('申领数量不能为空')
            save = false
            return
          }
          if (item.nums <= 0) {
            this.$message.warning('申领数量不能小于0')
            save = false
            return
          }
          if (item.nums > item.storage) {
            this.$message.warning('申领数量不能大于库存')
            save = false
            return
          }
          if ((item.materialType === '2' || item.materialType === '礼品物料') && !item.applyRemarks) {
            this.$message.warning('物料类型为礼品类时，申领用途必填')
            save = false
            return
          }
          item.orderId = this.order.id
          if (item.updateTime) {
            delete item.updateTime
          }
          data.push(item)
        })

        if (save) {
          saveOrderMaterial(data).then(res => {
            if (res.code === 1) {
              this.$message.success('保存成功')
              this.getData()
              this.getData1()
              resolve(true) // 保存成功，解决Promise
            } else {
              this.$message.error(res.message)
              console.log(this.uniqueCodes,'正式保存2')
              console.log(this.tableData,'tabledata')
              reject(new Error(res.message)) // 保存失败，拒绝Promise
            }
          }).catch(err => {
            reject(err)
          })
        } else {
          reject(new Error('校验失败')) // 校验失败，拒绝Promise
        }
      })
    },
    returnFun() {
      this.uniqueCodes.clear();
      this.returnListFun()
    },
    returnListFun() {
      // 跳转路由
      this.$closePage('/publicizeMaterialManagement/applyOrder', '/publicizeMaterialManagement/advertiseMaterialRequisition')
    },
    // 编辑物料信息
    editRowEvent(row) {
      const $table = this.$refs.xTable
      $table.setActiveRow(row)
      this.btnEnable = false
      this.editFlag = true
    },
    // 保存单条物料信息，未启用
    saveRowEvent() {
      const $table = this.$refs.xTable
      $table.clearActived().then(() => {
        // setTimeout(() => {
        //   this.gridOptions.loading = false
        // }, 300)
      })
    },
    // 取消编辑某行，临时数据会直接删除
    // cancelRowEvent(row) {
    //   const $table = this.$refs.xTable
    //   if (row.id) {
    //     $table.clearActived().then(() => {
    //     // 还原行数据
    //       $table.revertData(row)
    //     })
    //   } else {
    //     $table.clearActived().then(() => {
    //     // 删除数据
    //       $table.remove(row)
    //     })
    //   }
    //   this.btnEnable = true
    //   this.editFlag = false
    // }

    cancelRowEvent(row) {
      // 如果行有id，说明已被正式保存过
  if (row.id) {
    this.$message.warning('该物料已正式保存，无法临时取消')
    return
  }
      const $table = this.$refs.xTable
      // 调用表格的clearActived方法清除激活状态，返回Promise
        $table.clearActived().then(() => {
          // 检查物料号是否在uniqueCodes集合中
          // 检查row对象是否有materialCode属性  检查uniqueCodes集合中是否包含该materialCode
      if (row.materialCode && this.uniqueCodes.has(row.materialCode)) {
          this.uniqueCodes.delete(row.materialCode)
        // 删除数据
          $table.remove(row)
        }})
      }
  }
}

</script>

<style lang="less" scoped>
.orderFormLine {
  margin: 0;
  padding: 0px 20px;
  width: 100%;
  background: #0a76a4;
  color: #ffffff;
  height: 30px;
  line-height: 30px;
}
.order-btn {
  margin-top: 0px;
}
.ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 5px 0;
}

</style>
